export const columnsDataComplex = [
  {
    Header: "SR. NO.",
    accessor: "ser_no",
  },
  {
    Header: "NAME",
    accessor: "name",
  },
  {
    Header: "USER NAME / EMAIL",
    accessor: "username/email",
  },
  {
    Header: "EMAIL VERIFIED",
    accessor: "emailVerified",
  },
  {
    Header: "PHONE NUMBER",
    accessor: "phoneNumber",
  },
  {
    Header: "ACCOUNT TYPE",
    accessor: "accountType",
  },
  {
    Header: "CREATED AT",
    accessor: "createdAt",
  },
  {
    Header: "STATUS",
    accessor: "status",
  },
  {
    Header: "ACTION",
    accessor: "actionId",
  },
];
